import React from "react";
import { useTranslation } from "react-i18next";
import FeedbackModal from "../feedback/FeedbackModal";

const TECHNICAL_PATTERN = /(\bCode:|\bStatus:|\brest_|^Invalid parameter)/i;
const looksTechnical = (s) =>
  typeof s === "string" && TECHNICAL_PATTERN.test(s);

const ModalUpdateError = ({
  show,
  onHide,
  confirmHeader,
  confirmDescription,
  productsLink,
}) => {
  const { t } = useTranslation();

  // Future contract (Fase 3): epic emits an object
  // { userMessage, technicalDetail, code, status }.
  const payload =
    confirmDescription && typeof confirmDescription === "object"
      ? confirmDescription
      : null;
  const rawString = payload ? null : confirmDescription;
  const isRawTechnical = looksTechnical(rawString);

  const technicalDetail =
    payload?.technicalDetail ?? (isRawTechnical ? rawString : undefined);

  const title = confirmHeader ? t(confirmHeader) : t("feedback.error.title");

  const isProductNotFound =
    (payload?.code === "PRODUCT_NOT_FOUND" ||
      rawString === "Product not found") &&
    productsLink;

  let message;
  if (isProductNotFound) {
    message = (
      <>
        {payload?.userMessage
          ? t(payload.userMessage)
          : t("Please fill in all required fields")}
        <br />
        {t("You can add the product to WooCommerce manually at this address: ")}
        <a
          href={productsLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "underline" }}
        >
          {productsLink}
        </a>
      </>
    );
  } else if (payload?.userMessage) {
    message = t(payload.userMessage);
  } else if (isRawTechnical) {
    message = t("feedback.error.genericMessage");
  } else if (rawString) {
    message = t(rawString);
  } else {
    message = t("Please fill in all required fields");
  }

  return (
    <FeedbackModal
      show={show}
      onHide={onHide}
      severity="error"
      title={title}
      message={message}
      technicalDetail={technicalDetail}
    />
  );
};

export default ModalUpdateError;
